import { cn } from '@core/utils';

interface NewBadgeProps {
  dimensions?: 'H16' | 'H24';
}

export const NewBadge = ({ dimensions = 'H24' }: NewBadgeProps) => {
  return (
    <span
      className={cn(
        'flex rounded-xxsmall bg-P-550 font-700 text-Gray-white',
        {
          'min-h-24 px-6 py-2 typo-caption1 !leading-[20px]':
            dimensions === 'H24',
        },
        { 'h-16 px-4 typo-caption2': dimensions === 'H16' },
      )}
    >
      NEW
    </span>
  );
};
